<div class="ReceiptLookupLayout">
    <router-outlet name="header"></router-outlet>
    <router-outlet></router-outlet>
    <router-outlet name="footer"></router-outlet>
</div>
